import React from "react"
import { Calendar, Pencil, Trash2 } from "lucide-react"
import type { NoteCardViewModel } from "../types"
import { isNotePreviewLong } from "../utils/isNotePreviewLong"
import "./NoteCard.style.scss"

interface NoteCardProps {
  card: NoteCardViewModel
  removing: boolean
  editing: boolean
  onOpen: () => void
  onEdit: () => void
  onRemove: () => void
}

const NoteCard = ({
  card,
  removing,
  editing,
  onOpen,
  onEdit,
  onRemove,
}: NoteCardProps) => {
  const isLong = isNotePreviewLong(card.content)

  return (
    <article className={`note-card${editing ? " is-editing" : ""}`}>
      <div className={`note-card__banner is-${card.color}`}>
        <span>{card.subject}</span>
        <span className="note-card__date">
          <Calendar size={12} />
          {card.dateLabel}
        </span>
      </div>
      <div className="note-card__body">
        <button
          type="button"
          className="note-card__preview"
          disabled={removing}
          aria-label={`Open note ${card.title}`}
          onClick={onOpen}
        >
          <h3>{card.title}</h3>
          <p>{card.content}</p>
          {isLong ? <span className="note-card__more">Read more</span> : null}
        </button>
        <div className="note-card__footer">
          <button
            type="button"
            className="is-edit"
            aria-label="Edit note"
            disabled={removing}
            onClick={onEdit}
          >
            <Pencil size={16} />
          </button>
          <button
            type="button"
            className="is-delete"
            aria-label="Delete note"
            disabled={removing}
            onClick={onRemove}
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    </article>
  )
}

export default NoteCard
